import { Component } from "react";
import { Activity, RotateCcw } from "lucide-react";
import { SITE } from "../lib/site";
import { logError } from "../lib/log";

// Last-resort screen for a render crash: a calm message, a reload, and the live status page so families can check on us.
export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { try { logError("render", error, info?.componentStack); } catch (e) { /* noop */ } }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen bg-background text-foreground grid place-items-center px-6" data-testid="error-screen">
        <div className="max-w-md">
          <div className="text-[10px] uppercase tracking-widest font-mono text-primary">We're having trouble</div>
          <h1 className="font-serif text-3xl sm:text-4xl mt-2">This page didn't load the way it should.</h1>
          <p className="mt-3 text-sm text-muted-foreground leading-relaxed">Your documents are safe — nothing here changes what's in the vault. Reloading usually fixes it. If it keeps happening, check whether we're having a wider problem.</p>
          <div className="mt-6 flex flex-wrap gap-2">
            <button type="button" onClick={() => window.location.reload()} className="inline-flex items-center gap-1.5 rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm font-medium" data-testid="error-reload-btn"><RotateCcw className="h-4 w-4" /> Reload</button>
            <a href={SITE.statusUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 rounded-full border border-border px-4 py-2 text-sm hover:bg-muted" data-testid="error-status-link"><Activity className="h-4 w-4" /> Live status</a>
          </div>
        </div>
      </div>
    );
  }
}
